
// Format date for blog display
export const formatBlogDate = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }).format(date);
};

// Sort posts by date (newest first)
export const sortPostsByDate = <T extends { date: string }>(posts: T[]): T[] => {
  return [...posts].sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });
};
